import { BasicFieldInputs } from '../components/BasicFieldInputs';
import { AddRemoveItemList } from '../components/AddRemoveItemList';
import { Checkbox, Flex, Stack } from '@mantine/core';
import { useIntl } from 'react-intl';

export const PickerField = ({
  field,
  setField,
  option,
  setOption,
}: {
  field: any;
  setField: (field: any) => void;
  option: string;
  setOption: (option: string) => void;
}) => {
  const intl = useIntl();
  return (
    <Stack gap="md">
      <BasicFieldInputs
        fields={['label', 'description']}
        fieldValues={field}
        requiredFields={['label']}
        onChange={(key, value) => setField({ ...field, [key]: value })}
      />

      <Checkbox
        label={intl.formatMessage({ id: 'disabled' })}
        value={field.isDisabled}
        onChange={(event) =>
          setField({ ...field, isDisabled: event.currentTarget.checked })
        }
      />

      <AddRemoveItemList
        items={field.items || []}
        inputLabel="Options"
        inputValue={option}
        onInputChange={setOption}
        onAddItem={() => {
          if (option) {
            setField({
              ...field,
              items: [
                ...(field.items?.filter((item: any) => item.id !== option) ||
                  []),
                { id: option, label: option },
              ],
            });
            setOption('');
          }
        }}
        onRemoveItem={(index) => {
          setField({
            ...field,
            items: field.items.filter((_: any, i: number) => i !== index),
          });
        }}
        renderItem={(item) => (
          <Flex gap="xs" align="center">
            {item.label}
          </Flex>
        )}
        addButtonDisabled={!option}
      />
    </Stack>
  );
};
